import type { ChangeEvent } from "react"

import { CheckFilledIcon } from "../../../../../../assets/icons/shared"
import cx from "classnames"
import { useState } from "react"

import type { TextFieldProps } from "../.."

import { emailPattern } from "../../../../../../utils/patterns"
import styles from "../../index.module.css"
import { BaseField, IconWrapper } from "../baseField"

export const EmailField = ({ label, errorText, iconLeft, ...inputProps }: TextFieldProps) => {
  const [isValidEmail, setIsValidEmail] = useState<boolean>(false)

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    const isValid = value.length > 0 && emailPattern.test(value)

    setIsValidEmail(isValid)

    if (inputProps.onChange) {
      inputProps.onChange?.(e)
    }
  }

  return (
    <BaseField
      label={label}
      errorText={errorText}
      required={inputProps.required}
      disabled={inputProps.disabled}
      id={inputProps.id}
    >
      {iconLeft && <IconWrapper position="left">{iconLeft}</IconWrapper>}
      <input {...inputProps} pattern={emailPattern.source} onChange={handleInputChange} className={styles.input} />
      <IconWrapper position="right" className={cx({ [styles.invalidEmail]: !isValidEmail })}>
        <CheckFilledIcon />
      </IconWrapper>
    </BaseField>
  )
}
